module.exports = __webpack_public_path__ + "static/media/Artboard1.680af54b.png";